import { render } from "./CourseCategory.vue?vue&type=template&id=00b84e58&scoped=true"
import script from "./CourseCategory.vue?vue&type=script&lang=js"
export * from "./CourseCategory.vue?vue&type=script&lang=js"

import "./CourseCategory.vue?vue&type=style&index=0&id=00b84e58&lang=scss&scoped=true"

import exportComponent from "F:\\my_work_space\\cmall-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b84e58"]])

export default __exports__